import $ from 'jquery';
import slick from 'slick-carousel';

// FRONT PAGE
// ___________________________________________________
// Testimonials 
function frontPageTestimonialsSlider() {
	$('.js--testimonials-slider').slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		arrows: false,
		speed: 500,
		dots: true,
		infinite: true,
		cssEase: 'ease-in',
	});
}

// Logos
function frontPageLogosSlider() {
	$('.js--logos').slick({
		slidesToShow: 2,
		slidesToScroll: 2,
		arrows: false,
		speed: 500,
		dots: true,
		mobileFirst: true,
		infinite: true,
		cssEase: 'ease-in',
		responsive: [
			{
				breakpoint: 767,
				settings: {
					slidesToShow: 4,
					slidesToScroll: 4,
				}
			},
			{
				breakpoint: 1365,
				settings: {
					slidesToShow: 6,
					slidesToScroll: 6,
				}
			}
		]
	});
}
// SLIDERS INIT
// ___________________________________________________
if( $('.js--testimonials-slider').length ) {
	frontPageTestimonialsSlider();
}
if( $('.js--logos').length ) {
	frontPageLogosSlider();
}
